// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const TokenpayLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.1128 21.9809C12.0371 22.0067 11.963 22.0064 11.8875 21.9799C10.9176 21.6391 4 18.9393 4 11.2524V4.30385C4 4.12 4.12492 3.95974 4.30299 3.91515L11.903 2.01196C11.9667 1.99601 12.0333 1.99601 12.097 2.01196L19.697 3.91515C19.8751 3.95974 20 4.12 20 4.30385V11.2524C20 19.0169 13.084 21.6495 12.1128 21.9809Z" stroke={color} strokeWidth="1.5" stroke-miterlimit="10" strokeLinejoin="round" />
        <g clip-path="url(#clip0_10660_1670)">
            <path d="M12 14.25C14.071 14.25 15.75 12.571 15.75 10.5C15.75 8.42893 14.071 6.75 12 6.75C9.92893 6.75 8.25 8.42893 8.25 10.5C8.25 12.571 9.92893 14.25 12 14.25Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.125 9.1875C12.8681 8.93063 12.4158 8.75196 12 8.74077M12 8.74077C11.5053 8.72746 11.0625 8.95124 11.0625 9.5625C11.0625 10.6875 13.125 10.125 13.125 11.25C13.125 11.8916 12.5761 12.1673 12 12.1466M12 8.74077V8.0625M10.875 11.625C11.1167 11.9472 11.5661 12.131 12 12.1466M12 12.1466V12.9375" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_10660_1670">
                <rect width="9" height="9" fill="white" transform="translate(7.5 6)" />
            </clipPath>
        </defs>
    </svg>

);
